import * as klaro from '../../../../../../../build/node_modules/klaro';
// import vendor files here (Webpack automatically watches this file)
// eslint-disable-next-line import/no-extraneous-dependencies
// import * as klaro from 'klaro';
import KlaroWidget from './klaro-helper';

window.klaro = klaro;

document.querySelector('.change-consent').addEventListener('click', () => {
    klaro.show();
});
document.addEventListener('DOMContentLoaded', () => {
    klaro.setup();
    const klaroWidget = new KlaroWidget();
    klaroWidget.moveKlaro();
    klaroWidget.init();
});